import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';

import Element from 'types/redux/Element';
import ListCollection from 'types/redux/ListCollection';

import Article from 'models/Article';

import { ELEMENT_MARKUP, LIST_MARKUP } from 'consts/api';
import { fillPage } from 'utils/translations';

import {
    list as listArticles,
    single as singleArticle,
} from 'requests/articles';

import Component from './component';
import { Props } from './types';

export async function getServerSideProps(context: GetServerSidePropsContext): Promise<GetServerSidePropsResult<Props>> {
    let article: Element<Article> = ELEMENT_MARKUP;
    let articles: ListCollection<Article> = LIST_MARKUP;

    try {
        await Promise.all([
            singleArticle({ slug: context?.query?.slug.toString() }),
        ]).then(responses => {
            article = responses[0];
        });
    } catch (error) {
        console.error(error);
    }

    try {
        await Promise.all([
            listArticles({ page: 1, perPage: 3 }),
        ]).then(responses => {
            articles = responses[0]?.articles;
        });
    } catch (error) {
        console.error(error);
    }

    let pageTranslations = JSON.parse(JSON.stringify(require('locales/pl/pages/article')?.default));
    const fillValues = {};
    pageTranslations = fillPage(pageTranslations, null, fillValues);

    return {
        props: {
            pageTranslations,
            article: JSON.parse(JSON.stringify(article)),
            articles: JSON.parse(JSON.stringify(articles)),
        },
    };
}

export default Component;
